import { JsonFormat, stringJsonFormat } from "@redotech/json/format";

export namespace TriggerType {
  export const ORDER_CREATED = "order_created";
  export const PRE_TRANSIT = "pre_transit";
  export const IN_TRANSIT = "in_transit";
  export const OUT_FOR_DELIVERY = "out_for_delivery";
  export const DELIVERED = "delivered";
  export const PICKUP = "available_for_pickup";
  // Problem statuses
  export const STALLED = "stalled_in_transit";
  export const DELAYED = "delayed";
  export const ARRIVING_EARLY = "arriving_early";
  export const RETURN_TO_SENDER = "return_to_sender";
  export const DELIVERY_ATTEMPTED = "delivery_attempted";
  export const FAILURE = "failure";
  export const CANCELED = "canceled";
  export const ERROR = "error";
}

export type TriggerType =
  | typeof TriggerType.ORDER_CREATED
  | typeof TriggerType.PRE_TRANSIT
  | typeof TriggerType.IN_TRANSIT
  | typeof TriggerType.OUT_FOR_DELIVERY
  | typeof TriggerType.DELIVERED
  | typeof TriggerType.STALLED
  | typeof TriggerType.DELAYED
  | typeof TriggerType.ARRIVING_EARLY
  | typeof TriggerType.RETURN_TO_SENDER
  | typeof TriggerType.DELIVERY_ATTEMPTED
  | typeof TriggerType.FAILURE
  | typeof TriggerType.CANCELED
  | typeof TriggerType.ERROR;

export const triggerTypeJsonFormat: JsonFormat<TriggerType> = <
  JsonFormat<TriggerType>
>stringJsonFormat;
